import React from 'react'
import { connect } from 'formik'
import { FormattedMessage } from 'react-intl'
import Radio from '@iui-kit/components/Radio'
import GroupList from '../GroupList'
import { Formik } from '@src/types/BriefSearch/formikProps'

interface Inputs {
  label: string
  value: string
}

interface Props {
  name: string
  inputs: Inputs[]
}

interface HOCProps {
  formik: Formik
}

const RadioGroup: React.FC<Props & HOCProps> = props => {
  const {
    name,
    inputs,
    formik: { values, errors, touched, handleBlur, handleChange }
  } = props

  return (
    <GroupList name={name}>
      {inputs.map((input, idx) => (
        <Radio
          key={idx}
          name={name}
          value={input.value}
          isValid={!errors[name] || !touched[name]}
          checked={input.value === values[name]}
          onChange={handleChange}
          onBlur={handleBlur}
        >
          <FormattedMessage id={input.label} />
        </Radio>
      ))}
    </GroupList>
  )
}

export default connect<Props>(RadioGroup)
